(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/lobby/play/utils.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/lobby/play/utils.js');
"use strict";


const setTabIndexOnButton = (button, remove) => {
  if (button) {
    button.tabIndex = remove ? -1 : 0;
  }
};
const showTopHeader = function () {
  var _document$querySelect;
  let reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
  const profileIconButton = document.querySelector('.js-nav-user');
  const navHamburgerButton = document.querySelector('.js-nav-hamburger');
  const topContent = document.querySelector('#top-content');
  const accountBalanceBarHeight = ((_document$querySelect = document.querySelector('.account-balance-bar')) === null || _document$querySelect === void 0 ? void 0 : _document$querySelect.offsetHeight) || 0;
  const mainContent = document.querySelector('#main-content');
  mainContent && gsap.to(mainContent, 1, {
    paddingTop: reset ? '' : accountBalanceBarHeight + (topContent === null || topContent === void 0 ? void 0 : topContent.offsetHeight)
  });
  topContent && gsap.to(topContent, {
    duration: reset ? 0 : 1,
    y: 0,
    position: ''
  });
  navHamburgerButton && gsap.to(navHamburgerButton, {
    duration: reset ? 0 : 1,
    y: 0,
    onComplete: () => {
      setTabIndexOnButton(navHamburgerButton, false);
    }
  });
  profileIconButton && gsap.to(profileIconButton, {
    duration: reset ? 0 : 1,
    y: 0,
    onComplete: () => {
      setTabIndexOnButton(profileIconButton, false);
      window.dispatchEvent(new Event('resize'));
    }
  });
};
const hideTopHeader = () => {
  var _document$querySelect2;
  const profileIconButton = document.querySelector('.js-nav-user');
  const navHamburgerButton = document.querySelector('.js-nav-hamburger');
  const topContent = document.querySelector('#top-content');
  const accountBalanceBarHeight = ((_document$querySelect2 = document.querySelector('.account-balance-bar')) === null || _document$querySelect2 === void 0 ? void 0 : _document$querySelect2.offsetHeight) || 0;
  const mainContent = document.querySelector('#main-content');
  const heightDiff = topContent === null || topContent === void 0 ? void 0 : topContent.clientHeight;
  gsap.to(mainContent, 1, {
    paddingTop: accountBalanceBarHeight
  });
  gsap.to(topContent, 1, {
    y: -heightDiff,
    position: 'absolute'
  });
  gsap.to(navHamburgerButton, 1, {
    y: -heightDiff,
    onComplete: () => {
      setTabIndexOnButton(navHamburgerButton, true);
    }
  });
  gsap.to(profileIconButton, 1, {
    y: -heightDiff,
    onComplete: () => {
      setTabIndexOnButton(profileIconButton, true);
      window.dispatchEvent(new Event('resize'));
    }
  });
};
const onBreakPointChange = () => {
  if (svs.core.detect.breakpoint.greaterThan('md')) {
    showTopHeader();
  } else {
    hideTopHeader();
  }
};
const hideFooter = () => {
  var _document$querySelect3;
  (_document$querySelect3 = document.querySelector('.page-footer')) === null || _document$querySelect3 === void 0 || (_document$querySelect3 = _document$querySelect3.classList) === null || _document$querySelect3 === void 0 || _document$querySelect3.add('hide-page-footer');
};
const showFooter = () => {
  var _document$querySelect4;
  (_document$querySelect4 = document.querySelector('.page-footer')) === null || _document$querySelect4 === void 0 || (_document$querySelect4 = _document$querySelect4.classList) === null || _document$querySelect4 === void 0 || _document$querySelect4.remove('hide-page-footer');
};
const scrollToHashAnchor = function () {
  var _window$location$hash;
  let _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$fallbackToTop = _ref.fallbackToTop,
    fallbackToTop = _ref$fallbackToTop === void 0 ? false : _ref$fallbackToTop;
  const hash = (_window$location$hash = window.location.hash) === null || _window$location$hash === void 0 ? void 0 : _window$location$hash.replace('#', '');
  if (!hash) {
    if (fallbackToTop) {
      window.scrollTo(0, 0);
    }
    return false;
  }
  const target = document.getElementById(hash);
  if (!target) {
    if (fallbackToTop) {
      window.scrollTo(0, 0);
    }
    return false;
  }
  target.scrollIntoView({
    block: 'start'
  });
  return true;
};
const removeHashFromUrl = () => {
  if (!window.location.hash) {
    return false;
  }
  window.history.replaceState(null, '', "".concat(window.location.pathname).concat(window.location.search));
  return true;
};
const showOngoingDialog = onClose => {
  const dialog = new svs.components.dialog.Confirm({
    icon: 'exclamation-sign',
    branding: svs.components.dialog.branding.TUR,
    title: 'Hoppsan!',
    message: [{
      type: svs.components.dialog.message.TEXT,
      text: 'Du har redan ett spel som du inte spelat klart. <br/> Gör det innan du spelar ett nytt.',
      align: svs.ui.dialog.message.align.CENTER
    }, {
      type: svs.components.dialog.message.TEXT,
      text: 'Lycka till!',
      align: svs.ui.dialog.message.align.CENTER
    }],
    allowDimmerClick: false,
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
        onClose === null || onClose === void 0 || onClose();
      }
    }]
  });
  svs.components.dialog.api.add(dialog);
};
setGlobal('svs.eInstant.lobby.play.utils', {
  GAME_PROVIDERS: {
    LEIA: 'LEIA'
  },
  showOngoingDialog,
  hideFooter,
  showFooter,
  scrollToHashAnchor,
  removeHashFromUrl,
  hideHeaders: shouldHideTopHeader => {
    if (shouldHideTopHeader) {
      onBreakPointChange();
      svs.core.detect.breakpoint.on('change', onBreakPointChange);
    }
  },
  removeBreakPointListeners: () => {
    svs.core.detect.breakpoint.off('change', onBreakPointChange);
    showTopHeader(true);
  },
  getTicketInfoByUrl: function (gameUrl) {
    let games = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : svs.eInstant.data.categories;
    const allGames = games.flatMap(game => (game === null || game === void 0 ? void 0 : game.games) || game);
    return allGames.find(_ref2 => {
      let url = _ref2.url,
        type = _ref2.type;
      return url === gameUrl || type === gameUrl;
    });
  },
  getTicketInfoByWager: function (wager) {
    let games = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : svs.eInstant.data.categories;
    const allGames = games.flatMap(game => (game === null || game === void 0 ? void 0 : game.games) || game);
    const getTicketInfoByName = gameName => allGames.find(game => {
      var _game$name;
      return ((_game$name = game.name) === null || _game$name === void 0 ? void 0 : _game$name.toLowerCase()) === (gameName === null || gameName === void 0 ? void 0 : gameName.toLowerCase());
    });
    if (wager.productVersion === 1) {
      return allGames.find(game => {
        var _game$type, _wager$properties;
        return ((_game$type = game.type) === null || _game$type === void 0 ? void 0 : _game$type.toLowerCase()) === ((_wager$properties = wager.properties) === null || _wager$properties === void 0 || (_wager$properties = _wager$properties.externalProductCode) === null || _wager$properties === void 0 ? void 0 : _wager$properties.toLowerCase());
      });
    }
    return getTicketInfoByName(wager.description);
  },
  showReceipt: () => {
    const receipt = document.querySelector('#ticket-receipt');
    if (receipt) {
      gsap.to(receipt, {
        opacity: 1,
        duration: 2
      });
    }
  }
});

 })(window);